import { render, staticRenderFns } from "./MergedRequestBtn.vue?vue&type=template&id=81e7afca&"
import script from "./MergedRequestBtn.vue?vue&type=script&lang=js&"
export * from "./MergedRequestBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports